import React from "react";
import Button from "@irati/ui/src/Button";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import favouritesService from "@irati/deals/services/favourites";
import FormattedMessage from "@irati/utils/lang";
import IsDealFavourited from "@irati/deals/apollo/query/IsDealFavourited";
var FavouriteButton = function (_a) {
    var deal = _a.deal, className = _a.className, _b = _a.iconSize, iconSize = _b === void 0 ? 20 : _b, onChange = _a.onChange;
    var onClick = function (isFavourite) {
        if (onChange) {
            onChange(!isFavourite);
        }
        return isFavourite ? favouritesService.remove(deal) : favouritesService.add(deal);
    };
    var text = function (isFavourite) {
        if (isFavourite) {
            return React.createElement(FormattedMessage, { id: "perks.components.importantInfoBlock.favouriteButton.remove" });
        }
        return React.createElement(FormattedMessage, { id: "perks.components.importantInfoBlock.favouriteButton.save" });
    };
    return (React.createElement(IsDealFavourited, { dealId: deal.uuid }, function (_a) {
        var isFavourite = _a.isFavourite;
        return (React.createElement(Button, { tertiary: true, className: className, onClick: function () { return onClick(isFavourite); } },
            React.createElement(Icon, { icon: isFavourite ? IconTypes.favouriteFill : IconTypes.favourite, size: iconSize, marginRight: true }),
            text(isFavourite)));
    }));
};
export default FavouriteButton;
